import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const GAMES = [
  {
    id: 'minesweeper',
    name: 'BuscaMinis',
    emoji: '💣',
    desc: 'Encuentra las VACWAYminis ocultas en el tablero',
    accent: '#2563eb',
  },
  {
    id: 'flappybird',
    name: 'Flappy Locker',
    emoji: '🐦',
    desc: 'Vuela entre las taquillas sin chocar',
    accent: '#16a34a',
  },
];

const GamePicker = ({ isOpen, onSelect, onClose }) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="sm">
      <ModalHeader
        toggle={onClose}
        style={{
          background: '#0f172a',
          borderBottom: '1px solid #1e293b',
          color: '#f1f5f9',
        }}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          🎮 <span>Arcade ADMIN</span>
        </span>
      </ModalHeader>

      <ModalBody
        style={{
          background: '#0f172a',
          padding: '16px',
        }}
      >
        <p style={{ color: '#64748b', fontSize: '13px', margin: '0 0 14px 0' }}>
          Selecciona un juego
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {GAMES.map((game) => (
            <GameCard key={game.id} game={game} onSelect={onSelect} />
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
};

const GameCard = ({ game, onSelect }) => {
  const [hovered, setHovered] = React.useState(false);

  return (
    <button
      onClick={() => onSelect(game.id)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        padding: '14px 16px',
        background: hovered ? game.accent + '22' : '#1e293b',
        border: `1.5px solid ${hovered ? game.accent : '#334155'}`,
        borderRadius: '10px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        textAlign: 'left',
        width: '100%',
      }}
    >
      <span style={{ fontSize: '32px', lineHeight: 1 }}>{game.emoji}</span>
      <div>
        <div style={{ color: '#f1f5f9', fontWeight: 700, fontSize: '15px', marginBottom: '3px' }}>
          {game.name}
        </div>
        <div style={{ color: '#64748b', fontSize: '12px' }}>
          {game.desc}
        </div>
      </div>
      <span
        style={{
          marginLeft: 'auto',
          color: hovered ? game.accent : '#475569',
          fontSize: '18px',
          transition: 'color 0.15s',
        }}
      >
        ▶
      </span>
    </button>
  );
};

export default GamePicker;
